<template lang="pug">
.KSSDCCAssign
    .main(v-if="internal_document")
        

        div(v-if="!editing")
            .row().bg-primary.text-white
                .col-1
                    .small Seiten
                .col-5
                    .small KKS
                .col-1
                    .small M/E
                .col-1
                    .small DCC
                .col-2
                    .small Datum
                .col-2
                    .small Aktion

            .mb-1(v-for="(asgn, index) in internal_document.assignments" :key="'view-' + index")
                .row(v-bind:class="{ 'bg-light': asgn.start == 'all' }")
                    .col-1
                        template(v-if="asgn.start == null")
                            .small.mr-1() Alle
                        template(v-else)
                            b-link.small.mr-1(@click="$emit('setpage', asgn.start)") {{asgn.start}} - {{asgn.end}}
                    .col-5
                        .small.mr-1(v-if="asgn.selected_kks") {{asgn.selected_kks.join(', ')}}
                    .col-1
                        .small.mr-1(v-if="asgn.me_class") {{asgn.me_class}}
                    .col-1
                        .small.mr-1(v-if="asgn.selected_class") {{asgn.selected_class.join(', ')}}
                    .col-2
                        
                        .small.mr-1(v-if="asgn.best_date") {{asgn.best_date.text}}
                    .col-2
                        .small(v-if="asgn.export").mr-2 Export
                        .small(v-if="asgn.ignore") Ignore
                    
                        
            // align right
            .row
                .col-11
                .col-1
                    
                    b-btn(variant="primary", size="sm", @click="editing = true")
                            i.fas.fa-edit

        div(style="background: white; padding: 10px; border: 1px solid #ccc", v-if="editing").card
            .mb-1(v-for="(asgn, index) in internal_document.assignments", :key="index")
                .d-flex
                    .d-flex.justify-content-between(style="width: 230px")
                        el-select(class="select-primary pagination-select"  v-model="asgn.start" placeholder="Von", size="sm" :filterable="true" :default-first-option="true", :style="{width: asgn.start == null ? '100%' : '50%'}" @change="get_best_date(asgn)" :popper-append-to-body="false").mr-1.h-100
                            el-option(:value="null", label="Ges. Dokument") Gesamtes Dokument
                            el-option(v-for="k in getPageNumbersForSelect(internal_document.metadata.page_count)" :value="k", :key="k", :label="k") {{k}}
                        
                        template(v-if="asgn.start != null")
                            el-select(class="select-primary pagination-select" v-model="asgn.end" placeholder="Bis", size="sm" :filterable="true" :default-first-option="true", style="width: 50%" @change="get_best_date(asgn)" :popper-append-to-body="false").mr-1.h-100
                                el-option(v-for="k in getPageNumbersForSelect(internal_document.metadata.page_count, asgn.start)" :value="k", :key="k", :label="k") {{k}}
                
                
                    // Clickable KKS display or select based on active state
                    div(@click="activateKksSelect(index)" v-if="activeKksIndex !== index" class="kks-display clickable").mr-1.h-100.w-100
                        .kks-list(v-if="asgn.selected_kks && asgn.selected_kks.length")
                            .kks-item(v-for="(kks, kksIndex) in asgn.selected_kks" :key="kksIndex") {{ kks }}
                        .kks-empty(v-else) Click to select KKS
                    
                    div(v-else class="select-wrapper").mr-1.h-100.w-100
                        el-select(class="select-primary pagination-select" v-model="asgn.selected_kks" placeholder="KKS" multiple, :allow-create="true", size="sm" :filterable="true" :default-first-option="true" :remote="true" :remote-method="filterKks" :loading="kksLoading" :reserve-keyword="true" @change="maintainKksFilter" @visible-change="onKksVisibleChange").w-100.kks-select
                            el-option(v-for="item in filteredKksOptions" :value="item" :key="item" :label="item")
                    
                    
                    div.small
                        a(@click="take_top_kks(asgn); $event.preventDefault(); $event.stopPropagation();" href="javascript:void(0);").p-0.small.text-nowrap Vorh.<br/>
                        a(@click="clearKks(asgn); $event.preventDefault(); $event.stopPropagation();" href="javascript:void(0);").p-0.small.text-nowrap Lösch.<br/>
                        a(@click="take_all_kks(asgn); $event.preventDefault(); $event.stopPropagation();" href="javascript:void(0);").p-0.lh-sm.small.text-nowrap Alle<br/>
                        a(@click="take_best_kks(asgn); $event.preventDefault(); $event.stopPropagation();" href="javascript:void(0);").lh-sm.small.text-nowrap Beste<br/>
                        

                .d-flex.justify-content-between().mt-2

                    // Clickable DCC display or select based on active state
                    div(@click="activateDccSelect(index)" v-if="activeDccIndex !== index" class="dcc-display clickable").mr-1.h-100.w-100
                        .dcc-list(v-if="asgn.selected_class && asgn.selected_class.length")
                            .dcc-item(v-for="(dcc, dccIndex) in asgn.selected_class" :key="dccIndex") 
                                | {{ dcc }}
                                span.dcc-label(v-if="dcc_labels[dcc]") - {{ dcc_labels[dcc] }}
                        .dcc-empty(v-else) Click to select DCC
                    
                    div(v-else class="select-wrapper").mr-1.h-100.w-100
                        el-select(class="select-primary pagination-select" v-model="asgn.selected_class" placeholder="DCC" multiple, :allow-create="true", size="sm" :filterable="true" :default-first-option="true" :remote="true" :remote-method="filterDcc" :loading="dccLoading" :reserve-keyword="true" @change="maintainDccFilter" @visible-change="onDccVisibleChange").w-100.dcc-select
                            el-option(v-for="item in filteredDccOptions" :value="item" :key="item" :label="item") {{item}} {{  dcc_labels[item] }}
                    
                    b-select(v-model="asgn.me_class", :options="[{value: 'M', text: 'M'}, {value: 'E', text: 'E'}, {value: null, text: ''}]", size="sm", style="max-width: 50px").mr-1.h-100.p-2

                    b-input(v-model="asgn.best_date.text", type="text", placeholder="Datum", size="sm", style="width: 120px").mr-1.h-100.p-2
                    
                    
                    div
                        b-check(v-model="asgn.export", type="checkbox", size="sm", switch).mr-1
                            |  Export
                        b-check(v-model="asgn.ignore", type="checkbox", size="sm", switch).mr-1
                            |  Ignore
                    div
                        b-btn(variant="link", size="sm", @click="remove_assignment(asgn)")
                            i.fas.fa-trash-alt
                
                hr.my-4
                    
            // add assignment
            .mt-2
                // align right
                .d-flex.justify-content-end
                    b-btn(variant="primary", size="sm", @click="add_new(internal_document.assignments)")
                        i.fas.fa-plus
                        
            .mt-2
                .d-flex.justify-content-between.align-items-center
                    
                
                    b-btn(variant="primary", size="sm", @click="save").w-100
                        i.fas.fa-times
                        |  Schließen
            


            

                
</template>
<script >
export default {
    name: 'KSSDCCAssign',
    data() {
        return {
            internal_document: {},
            editing: false,
            filteredKksOptions: [],
            filteredDccOptions: [],
            kksLoading: false,
            dccLoading: false,
            kksSearchCache: {},
            dccSearchCache: {},
            kksSearchQuery: '',
            dccSearchQuery: '',
            activeKksIndex: null, // Track which KKS select is currently active
            activeDccIndex: null  // Track which DCC select is currently active
        }
    },
    props: {

        dcc_labels: {
            type: Object,
            default: function () {
                return {};
            }
        },
        
        document: {
            type: Object,
            default: function () {
                return {};
            }
        },
        kks_options: {
            type: Array,
            default: function () {
                return [];
            }
        },
        dcc_options: {
            type: Array,
            default: function () {
                return [];
            }
        },
        export: {
            type: Boolean,
            default: false
        }
    
    },

    watch: {
        document: {
            handler: function (val, oldVal) {
                
                this.internal_document = val;

                if(!this.internal_document.assignments) {
                    this.internal_document.assignments = [];
                }

                this.internal_document.assignments.forEach(asgn => {
                    if(!asgn.best_date) {
                        asgn.best_date = {text: ''};
                    }
                });
                
                
                
                // Reset filtered options only when no select is actively open
                if (this.activeKksIndex === null) {
                    this.filteredKksOptions = this.kks_options.filter(k => k != null).slice(0, 50);
                    this.kksSearchQuery = '';
                } else if (this.kksSearchQuery) {
                    this.filterKks(this.kksSearchQuery);
                }
                if (this.activeDccIndex === null) {
                    this.filteredDccOptions = this.dcc_options.filter(d => d != null).slice(0, 50);
                    this.dccSearchQuery = '';
                } else if (this.dccSearchQuery) {
                    this.filterDcc(this.dccSearchQuery);
                }
                // Clear caches when document changes
                this.kksSearchCache = {};
                this.dccSearchCache = {};
            },
            deep: true
        },
        
        // Watch for changes in options
        kks_options: {
            handler: function(val) {
                if (this.activeKksIndex === null) {
                    this.filteredKksOptions = val.filter(k => k != null).slice(0, 50);
                    this.kksSearchQuery = '';
                } else if (this.kksSearchQuery) {
                    this.filterKks(this.kksSearchQuery);
                }
                this.kksSearchCache = {}; // Clear cache when options change
            }
        },
        
        dcc_options: {
            handler: function(val) {
                if (this.activeDccIndex === null) {
                    this.filteredDccOptions = val.filter(d => d != null).slice(0, 50);
                    this.dccSearchQuery = '';
                } else if (this.dccSearchQuery) {
                    this.filterDcc(this.dccSearchQuery);
                }
                this.dccSearchCache = {}; // Clear cache when options change
            }
        }
    },

    mounted() {
        this.internal_document = this.document;

        if(!this.internal_document.assignments) {
            this.internal_document.assignments = [];
        }

        this.internal_document.assignments.forEach(asgn => {
            if(!asgn.best_date) {
                asgn.best_date = {text: ''};
            }
        });

        if(!Array.isArray(this.internal_document.selected_kks)) {
            this.internal_document.selected_kks = [];
        }
        if(!Array.isArray(this.internal_document.selected_class)) {
            this.internal_document.selected_class = [];
        }

        this.internal_document.assignments = this.internal_document.assignments.sort((a,b) => {
                if(a.start == null) return -1;
                if(b.start == null) return 1;
                return a.start - b.start;
        });
        // sort all selected KKS in assignment (filter out null/undefined first)
        this.internal_document.assignments.forEach(asgn => {
            asgn.selected_kks = (asgn.selected_kks || []).filter(k => k != null).sort();
            asgn.selected_class = (asgn.selected_class || []).filter(d => d != null).sort();
        });
        
        // Initialize filtered options with a limited subset
        this.filteredKksOptions = this.kks_options.filter(k => k != null).slice(0, 50);
        this.filteredDccOptions = this.dcc_options.filter(d => d != null).slice(0, 50);

        // Reset active selects
        this.activeKksIndex = null;
        this.activeDccIndex = null;
        
        
    },
    
    beforeDestroy() {
        // Clean up the event listener
        this.activeKksIndex = null;
        this.activeDccIndex = null;
        
    },

    methods: {

        add_new(assignments) {
            // if previous assignment has KKS, take over
            let new_kks = []
            if(assignments.length > 0 && assignments[assignments.length-1].selected_kks.length > 0) {
                new_kks = assignments[assignments.length-1].selected_kks;
            }
                
            assignments.push({start: null, end: null, selected_kks: new_kks, selected_class: [], me_class: null, best_date: {text: ''}, export: false, ignore: false});
        },

        take_all_kks(asgn) {
            const index = this.internal_document.assignments.indexOf(asgn);
            asgn.selected_kks = this.internal_document.selected_kks = this.internal_document.kks_findings.map(f => f.kks).filter(k => k != null);
            
            // Ensure the KKS select stays active
            if (this.activeKksIndex !== index) {
                this.activateKksSelect(index);
            } else {
                // If already active, make sure it stays active
                this.refocusKksSelect();
            }
        },

        take_best_kks(asgn) {
            if(this.internal_document.kks_findings.length == 0) {
                alert("No KKS findings available");
                return;
            }
            
            const index = this.internal_document.assignments.indexOf(asgn);
            const bestKks = this.internal_document.kks_findings.map(f => f.kks).filter(k => k != null)[0];
            asgn.selected_kks = this.internal_document.selected_kks = bestKks ? [bestKks] : [];
            
            // Ensure the KKS select stays active
            if (this.activeKksIndex !== index) {
                this.activateKksSelect(index);
            } else {
                // If already active, make sure it stays active
                this.refocusKksSelect();
            }
        },

        take_top_kks(asgn) {
            // take over kks from prev assignment
            const index = this.internal_document.assignments.indexOf(asgn);
            if(index > 0) {
                const prevKks = (this.internal_document.assignments[index-1].selected_kks || []).filter(k => k != null);
                asgn.selected_kks = this.internal_document.selected_kks = [...prevKks];
            }
            
            // Ensure the KKS select stays active
            if (this.activeKksIndex !== index) {
                this.activateKksSelect(index);
            } else {
                // If already active, make sure it stays active
                this.refocusKksSelect();
            }
        },

        get_best_date(asgn) {
            
            let changed = false;

            console.log(asgn.start, asgn.end);
            this.internal_document.document_pages.page_list.forEach(page => {

                if(page.page+1 >= asgn.start && page.page+1 <= asgn.end && !changed) {
                    
                    if(page.best_date) {
                        console.log(page.best_date);
                        asgn.best_date = page.best_date;
                        changed = true;  
                    }
                }
            });
        },

        remove_assignment(asgn) {
            this.internal_document.assignments = this.internal_document.assignments.filter(a => a !== asgn);
        },

        save() {
            // Deactivate any active selects
            this.activeKksIndex = null;
            this.activeDccIndex = null;
            
            // sort all assignments by page
            this.internal_document.assignments = this.internal_document.assignments.sort((a,b) => {
                if(a.start == null) return -1;
                if(b.start == null) return 1;
                return a.start - b.start;
            });
            // sort all selected KKS in assignment (filter out null/undefined first)
            this.internal_document.assignments.forEach(asgn => {
                asgn.selected_kks = (asgn.selected_kks || []).filter(k => k != null).sort();
                asgn.selected_class = (asgn.selected_class || []).filter(d => d != null).sort();
            });
            this.$emit('save', this.internal_document);
            this.editing = false;
        },

        filterKks(query) {
            const normalizedQuery = (query || '').trim();
            if (normalizedQuery) {
                this.kksSearchQuery = normalizedQuery;
            } else if (this.kksSearchQuery && this.activeKksIndex !== null) {
                // Element UI may pass empty query after multi-select; keep filtered view
                query = this.kksSearchQuery;
            }

            if (!query) {
                if (this.activeKksIndex !== null && this.internal_document.assignments[this.activeKksIndex]) {
                    const currentKks = (this.internal_document.assignments[this.activeKksIndex].selected_kks || []).filter(k => k != null);
                    const baseOptions = this.kks_options.filter(k => k != null).slice(0, 50);
                    this.filteredKksOptions = [...new Set([...currentKks, ...baseOptions])];
                } else {
                    this.filteredKksOptions = this.kks_options.filter(k => k != null).slice(0, 50);
                }
                return;
            }
            
            // Check cache first
            if (this.kksSearchCache[query]) {
                this.filteredKksOptions = this.kksSearchCache[query];
                return;
            }
            
            this.kksLoading = true;
            
            // Debounce to prevent excessive filtering
            clearTimeout(this._kksSearchTimeout);
            this._kksSearchTimeout = setTimeout(() => {
                const lowerQuery = query.toLowerCase();
               
                let results = this.kks_options
                    .filter(item => item != null && item.toLowerCase().includes(lowerQuery))
                    .slice(0, 50); // Limit results for better performance
                
                // remove duplicates
                results = [...new Set(results)];

                // Cache the results
                this.kksSearchCache[query] = results;
                this.filteredKksOptions = results;
                this.kksLoading = false;
            }, 300);
        },
        
        filterDcc(query) {
            const normalizedQuery = (query || '').trim();
            if (normalizedQuery) {
                this.dccSearchQuery = normalizedQuery;
            } else if (this.dccSearchQuery && this.activeDccIndex !== null) {
                query = this.dccSearchQuery;
            }

            if (!query) {
                if (this.activeDccIndex !== null && this.internal_document.assignments[this.activeDccIndex]) {
                    const currentDcc = (this.internal_document.assignments[this.activeDccIndex].selected_class || []).filter(d => d != null);
                    const baseOptions = this.dcc_options.filter(d => d != null).slice(0, 50);
                    this.filteredDccOptions = [...new Set([...currentDcc, ...baseOptions])];
                } else {
                    this.filteredDccOptions = this.dcc_options.filter(d => d != null).slice(0, 50);
                }
                return;
            }
            
            // Check cache first
            if (this.dccSearchCache[query]) {
                this.filteredDccOptions = this.dccSearchCache[query];
                return;
            }
            
            this.dccLoading = true;
            
            // Debounce to prevent excessive filtering
            clearTimeout(this._dccSearchTimeout);
            this._dccSearchTimeout = setTimeout(() => {
                const lowerQuery = query.toLowerCase();
                let results = this.dcc_options
                    .filter(item => item != null && (item.toLowerCase().includes(lowerQuery) || 
                            (this.dcc_labels[item] && this.dcc_labels[item].toLowerCase().includes(lowerQuery))))
                    .slice(0, 50);

                // remove duplicates
                results = [...new Set(results)];
                
                // Cache the results
                this.dccSearchCache[query] = results;
                this.filteredDccOptions = results;
                this.dccLoading = false;
            }, 300);
        },

        maintainKksFilter() {
            this.$nextTick(() => {
                if (this.kksSearchQuery) {
                    this.filterKks(this.kksSearchQuery);
                }
            });
        },

        maintainDccFilter() {
            this.$nextTick(() => {
                if (this.dccSearchQuery) {
                    this.filterDcc(this.dccSearchQuery);
                }
            });
        },

        onKksVisibleChange(visible) {
            if (!visible) {
                this.kksSearchQuery = '';
            } else if (this.kksSearchQuery) {
                this.$nextTick(() => this.filterKks(this.kksSearchQuery));
            }
        },

        onDccVisibleChange(visible) {
            if (!visible) {
                this.dccSearchQuery = '';
            } else if (this.dccSearchQuery) {
                this.$nextTick(() => this.filterDcc(this.dccSearchQuery));
            }
        },

        getPageNumbersForSelect(pageCount, minPage = 1) {
            return Array.from({length: pageCount}, (_, i) => i + 1).filter(num => num >= minPage);
            
        },

        activateKksSelect(index) {
            // If we're activating a different KKS select, deactivate the current one
            if (this.activeKksIndex !== null && this.activeKksIndex !== index) {
                this.activeKksIndex = null;
            }
            
            // Deactivate any active DCC select since we're now working with KKS
            this.activeDccIndex = null;
            
            // Activate the requested KKS select
            this.activeKksIndex = index;
            this.kksSearchQuery = '';
            
            // Pre-load the options for this select
            if (this.internal_document.assignments[index]) {
                const currentKks = (this.internal_document.assignments[index].selected_kks || []).filter(k => k != null);
                // Include current selections in the filtered options
                const currentOptions = this.kks_options.slice(0, 30).filter(k => k != null);
                this.filteredKksOptions = [...new Set([...currentKks, ...currentOptions])];
            }
        },

        deactivateKksSelect() {
            this.activeKksIndex = null;
        },

        activateDccSelect(index) {
            // If we're activating a different DCC select, deactivate the current one
            if (this.activeDccIndex !== null && this.activeDccIndex !== index) {
                this.activeDccIndex = null;
            }
            
            // Deactivate any active KKS select since we're now working with DCC
            this.activeKksIndex = null;
            
            // Activate the requested DCC select
            this.activeDccIndex = index;
            this.dccSearchQuery = '';
            
            // Pre-load the options for this select
            if (this.internal_document.assignments[index]) {
                const currentDcc = (this.internal_document.assignments[index].selected_class || []).filter(d => d != null);
                // Include current selections in the filtered options
                const currentOptions = this.dcc_options.slice(0, 30).filter(d => d != null);
                this.filteredDccOptions = [...new Set([...currentDcc, ...currentOptions])];
            }
        },

        deactivateDccSelect() {
            this.activeDccIndex = null;
        },

        
        
        
        
        
        clearKks(asgn) {
            // Clear KKS but keep select active
            const index = this.internal_document.assignments.indexOf(asgn);
            asgn.selected_kks = [];
            
            // Ensure the KKS select stays active
            if (this.activeKksIndex !== index) {
                this.activateKksSelect(index);
            } else {
                // If already active, make sure it stays active
                
            }
        },
        
        handleOutsideClick(event) {
            // Check if we have any active selects
            const hasActiveSelect = this.activeKksIndex !== null || this.activeDccIndex !== null;
            if (hasActiveSelect) {
                // Check if the click was inside a select element (KKS or DCC)
                let isKksClick = false;
                let isDccClick = false;
                let isKksDisplay = false;
                let isDccDisplay = false;
                let isSaveButton = false;
                let target = event.target;
                
                // Walk up the DOM tree to find if the click was inside a select or option
                while (target) {
                    if (target.classList) {
                        // Check if click is on a KKS element
                        if (target.classList.contains('kks-select') || 
                            target.classList.contains('el-select-dropdown') ||
                            target.classList.contains('el-tag') ||
                            target.classList.contains('el-tag__close')) {
                            isKksClick = true;
                        }
                        
                        if (target.classList.contains('kks-display')) {
                            isKksDisplay = true;
                        }
                        
                        // Check if click is on a DCC element
                        if (target.classList.contains('dcc-select') ||
                            target.classList.contains('el-select-dropdown') ||
                            target.classList.contains('el-tag') ||
                            target.classList.contains('el-tag__close')) {
                            isDccClick = true;
                        }
                        
                        if (target.classList.contains('dcc-display')) {
                            isDccDisplay = true;
                        }
                    }
                    
                    // Check if save button was clicked
                    if (target.tagName === 'BUTTON' && 
                        target.textContent && 
                        target.textContent.includes('Schließen')) {
                        isSaveButton = true;
                    }
                    
                    target = target.parentNode;
                }
                
                // Only switch between selects when clicking on a different display
                if (this.activeKksIndex !== null && isDccDisplay && !isKksDisplay) {
                    this.deactivateKksSelect();
                }
                
                if (this.activeDccIndex !== null && isKksDisplay && !isDccDisplay) {
                    this.deactivateDccSelect();
                }
            }
        },
    
    }
};
</script>
<style>
.kks-select, .dcc-select {
    .el-select__tags-text {
        font-size: 10px;
    }
}

/* Common styles for both KKS and DCC displays */
.kks-display, .dcc-display {
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    padding: 0.5rem;
    cursor: pointer;
    min-height: 2rem;
    background-color: #fff;
    position: relative;
    overflow-y: auto;
    max-height: 150px; /* Limit height and add scrolling for many items */
}

.clickable::after {
    content: "🖱️";
    position: absolute;
    top: 3px;
    right: 3px;
    font-size: 10px;
    color: #409eff;
    opacity: 0.7;
}

.kks-display:hover, .dcc-display:hover {
    border-color: #409eff;
    background-color: #f5f7fa;
}

.kks-list {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    width: 100%;
}

.kks-item {
    display: inline-block;
    background-color: #f0f8ff;
    border: 1px solid #e6f1fc;
    border-radius: 3px;
    padding: 2px 6px;
    font-size: 0.875rem;
    margin-bottom: 3px;
}

.kks-comma-list, .dcc-comma-list {
    font-size: 0.875rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
}

.kks-empty, .dcc-empty {
    color: #a0a0a0;
    font-style: italic;
}

.dcc-select {
    .el-select__tags-text {
        font-size: 10px;
    }
}

.dcc-list {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    width: 100%;
}

.dcc-item {
    display: inline-block;
    background-color: #f0fff0;
    border: 1px solid #e6fce6;
    border-radius: 3px;
    padding: 2px 6px;
    font-size: 0.875rem;
    margin-bottom: 3px;
}

.dcc-label {
    font-size: 0.75rem;
    color: #606266;
    margin-left: 3px;
}

.dcc-empty {
    color: #a0a0a0;
    font-style: italic;
}

/* Performance optimizations for dropdowns */
.el-select-dropdown__item {
    padding: 4px 8px !important; /* Reduce item padding */
}

.el-select-dropdown {
    max-height: 300px; /* Limit dropdown height */
}

/* Reduce animation transition time for better performance */
.el-select-dropdown {
    transition: transform 0.1s ease-in-out, opacity 0.1s ease-in-out !important;
}

/* Select wrapper styles */
.select-wrapper {
    position: relative;
    display: flex;
}
</style>
    